(function () {

  function ingredientsInit() {
    document.addEventListener('DOMContentLoaded', function () {
      const navItems = document.querySelectorAll('.nav-item');
      const ingredients = document.querySelectorAll('.ingredient');
      const ingredientImages = document.querySelectorAll('.ingredient-image');
      const productIngredients = document.querySelector('.product-ingredients');

      function setActive(index) {
        navItems.forEach((item, i) => {
          item.classList.toggle('active', i === index);
        });
        ingredients.forEach((item, i) => {
          item.classList.toggle('active', i === index);
        });
        ingredientImages.forEach((item, i) => {
          item.classList.toggle('active', i === index);
        });
      }

      navItems.forEach((item, index) => {
        item.addEventListener('click', () => setActive(index));
      });

      let startX = 0;
      productIngredients.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });

      productIngredients.addEventListener('touchend', (e) => {
        const endX = e.changedTouches[0].clientX;
        const diffX = startX - endX;

        if (Math.abs(diffX) > 50) { // Threshold for swipe
          const activeIndex = Array.from(navItems).findIndex(item => item.classList.contains('active'));
          let newIndex = activeIndex;

          if (diffX > 0) {
            // Swipe left
            newIndex = (activeIndex + 1) % navItems.length;
          } else {
            // Swipe right
            newIndex = (activeIndex - 1 + navItems.length) % navItems.length;
          }

          setActive(newIndex);
        }
      });
    });
  }

  document.addEventListener("shopify:section:load", function (e) {
    ingredientsInit();
  });

  ingredientsInit();
})();
